import { TagsOverlaySizedTag, TagsOverlayTag } from "../types";

const parseTagsOverlaySizedTags = (
	inputTags: TagsOverlayTag[],
	{
		photoScreenWidth,
		photoScreenHeight,
	}: {
		photoScreenWidth: number;
		photoScreenHeight: number;
	},
): TagsOverlaySizedTag[] => {
	const tags: TagsOverlaySizedTag[] = [];
	for (const tag of inputTags) {
		if (tag.labelDim == null) {
			continue;
		}
		tags.push({
			...tag,
			labelDim: tag.labelDim,
			face: {
				x: tag.x * photoScreenWidth,
				y: tag.y * photoScreenHeight,
				width: tag.width * photoScreenWidth,
				height: tag.height * photoScreenHeight,
			},
		});
	}

	return tags;
};
export default parseTagsOverlaySizedTags;
